module.exports = __webpack_public_path__ + "img/ru.519b47c0.svg";